/**
 * Combines class names and resolves conflicting Tailwind utilities, so later
 * classes win.
 *
 * Re-exported from the `cn` package so consumers keep a single import path and
 * the underlying implementation can be swapped without touching call sites.
 *
 * @example
 * cn("px-2 py-1", isActive && "bg-blue-500", "px-4") // "py-1 bg-blue-500 px-4"
 */
export { cn } from "cn"
